<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="purchase-order"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :headerScreenJson="getHeaderScreenJson"
    :serverError="serverError"
    :getHeaderToolbar="getHeaderToolbar"
    :paging="false"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  getDefaultUserSettings,
  // getDefaultCustomerSettings,
  // getDefaultUserSettings,
  getFactorByCode,
} from "../../_store/helpers";
import { mapGetters } from "vuex";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import { PurchaseOrderDetail } from "../../_services/api/purchasing/purchase-order-detail.service";
import { formatNumber } from "devextreme/localization";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import { GoodsInService } from "../../_services/api/purchasing/goods-in.service";
import { FeatureStorage } from "../../_services/storage";
import { ProductService } from "../../_services/api/products/product.service";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
var glEntryDataSet = {
  Code: undefined,
  Description: undefined,
  Inactive: "N",
  BranchCode: undefined,
  BranchDescription: undefined,
  DivisionCode: undefined,
  DivisionDescription: undefined,
  RequiredByDate: undefined,
  ETADate: undefined,
  SupplierUM: undefined,
  SupplierRequired: 0,
  SupplierReceivedQty: 0,
  IsBatchProduct: "No",
  SupplierFXPrice: 0,
  FXLineTotal: 0,
  ItemCode: undefined,
  ItemDescription: undefined,
  ItemType: "G",
  TaxableFXLineTotal: 0,
  TaxFXLineTotal: 0,
  FXTotal: 0,
  TotalWithTax: 0,
  LineNo: 0,
  SupplierConversion: 1,
  SupplierPrice: 0,
  TaxPcnt: 0,
  IsVariable: "N",
  IsCopyLine: false,
  // CopyCode: undefined,
  TaxCode: undefined,
  Comment: "",
  IsGLEntry: true,
};

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,

      model: {
        ContainsManualBatch: false,
        Authorised1: "",
        Authorised2: "",
        AuthorisedBy: "",
        AutoGenerated: "",
        B2BSupplierReferenceNo: "",
        ChangedBy: "",
        Code: "",
        Comment1: "",
        Comment2: "",
        Comment3: "",
        Comment4: "",
        Comment5: "",
        Confirmed: "",
        CreatedBy: "",
        CurrencyCode: "",
        DateAuthorised: "",
        DateIn: "",
        DateInto: null,
        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: "",
        DeliveryAddressState: "",
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        DeliveryInstruction1: "",
        DeliveryInstruction2: "",
        DeliveryMonth: "",
        ExchangeRate: "",
        GoodsReceived: false,
        Name: "",
        NextStatus: "",
        Note: "",
        ProcessStatus: "",
        RecordId: "",
        Status: "C",
        SupplierCode: undefined,
        SupplierName: undefined,
        View: "",
        GoodsIn: false,
        Supplier: {
          Code: "",
          CurrencyCode: "",
          Fax1: "",
          InternationalFax: "",
          InternationalPhone: "",
          MailAddressCountry: "",
          MailAddressPostcode: "",
          MailAddressState: "",
          MailAddressStreetLine1: "",
          MailAddressStreetLine2: "",
          MailAddressSuburb: "",
          Name: "",
          Phone1: "",
          PhysicalAddressCountry: "",
          PhysicalAddressPostcode: "",
          PhysicalAddressState: "",
          PhysicalAddressStreetLine1: "",
          PhysicalAddressStreetLine2: "",
          PhysicalAddressSuburb: "",
          Status: "",
          SupplierTypeCode: "",
          WithholdingTaxRate: "",
        },
        CompanyCurrency: "",
        BranchCode: undefined,
        DivisionCode: undefined,
        BranchChanged: false,
        DivisionChanges: false,
        DeliverTo: undefined,
      },
      // model: {
      //   Status: "D",
      //   GoodsReceived: false,
      // },
      taxDataSourceItems: [],
      reload: false,
      validationSummary: [],
      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
        ETADate: undefined,
      },
      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      taxCodeDataSourceItems: [],

      brokenGridValidations: [],
      serverError: {},
      screenSettings: [],
      cancelCompleteMenu: [],
      branchPlaceHolder: "Select",
      divisionPlaceHolder: "Select",
      glEntryLocalItems: [],
      glChartDataSourceItems: [],
      glChartDataSourceItems2: [],
    };
  },

  async created() {
    // this.$store.dispatch("dataContext/setDataViewType", "general-ledger");
  },
  async mounted() {
    this.setBranchDataSourceItems();
    this.setDivisionDataSourceItems();
    this.setTaxCodeDataSourceItems();
    await this.beforeInit();
    await this.setGLChartDataSourceItems();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  watch: {
    $route(to) {
      if (to.path == "/purchase-order/create") {
        location.reload();
      }
      if (this.baseView.mode == "edit") {
        this.reload = true;
        setTimeout(() => {
          this.reload = false;
        }, 250);
      }
    },
  },

  computed: {
    getDataModel() {
      return this.model;
    },
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return "/purchase-order";
    },
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ searchText: "dataContext/getSearchText" }),
    getScreenJson() {
      var screenJson = {
        title: "Purchase Order",
        endpoint: {
          primary:
            this.baseView.mode !== "create" ? "PurchaseOrder" : undefined,
          expand: "Supplier",
          postProcess: this.purchaseOrderPostProcess,
        },

        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint: "InvoiceDetail",
              // filter: ["InvoiceCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              //   postProcessCallback: this.PostProcess,
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "add-new",
                  title: "No Order Lines",
                  message: "Get Started, Add a PO Line",
                },
              },
              "product-list": {
                addNew: {
                  class: "no-data",
                  title: "No Product Lines",
                  message: this.model.SupplierCode
                    ? "Products will show if the Supplier is a supplier of the product.  Head over to the Product screen to nominate the suppiler of the product."
                    : "Products will show when a Supplier is selected.",
                },
              },
              "general-ledger": {
                addNew: {
                  class: "no-data",
                  title: "No Order Lines",
                  message:
                    "GL Accounts must be in the system for them to appear here.  Head over to the GL Chart screen to start adding them.",
                },
              },
              addNew: {
                class: "add-new",
                title: "No Order Lines",
                message: "Get Started, Add a PO Line",
              },
            },
            // dynamicColumns: true,
            dataGridViews: [
              {
                label: "Review",
                value: "review",
                default: true,
                dataSource: {
                  items: [],
                  postProcessCallback: this.ReviewModePostProcess,
                },
                columns: this.getReviewColumns,
              },
              {
                label: "Product",
                value: "product-list",
                default: false,
                dataSource: {
                  endpoint: "ProductPurchaseList",
                  filter: ["SupplierCode", "=", `${this.model.SupplierCode}`],
                  serverPaging: false,
                  allowGrouping: false,
                  orderby: "ProductDescription1",
                  // // select: ["Code", "Description"],
                  postProcessCallback: this.ProductPostProcess,
                  key: "ProductCode",
                  keyType: {
                    ProductCode: "String",
                  },
                  fieldTypes: {
                    ProductCode: "String",
                    // Include: "Boolean",
                  },
                  // localDataList: true,
                  // items: this.productEntryLocalItems,
                },
                columns: this.getProductColumns,
              },
              {
                label: "GL List",
                value: "general-ledger",
                default: false,
                dataSource: {
                  // endpoint: "GLChart",
                  // filter: this.gLChartDataSourceFilter(),
                  serverPaging: true,
                  allowGrouping: false,
                  orderby: "Description",
                  // select: ["Code", "Description"],
                  // postProcessCallback: this.GLChartPostProcess,
                  postProcessCallback: this.GLChartEntryPostProcess,
                  // key: "Code",
                  // keyType: {
                  //   Code: "Int32",
                  // },
                  // fieldTypes: {
                  //   Code: "Int32",
                  //   // Include: "Boolean",
                  // },
                  localDataList: true,
                  items: this.glChartDataSourceItems2,
                },
                columns: this.getGLChartColumns,
              },
              {
                label: "GL Entry",
                value: "general-ledger-entry",
                default: false,
                dataSource: {
                  // endpoint: "GLChart",
                  // filter: this.gLChartDataSourceFilter(),
                  serverPaging: true,
                  allowGrouping: false,
                  orderby: "Description",
                  // select: ["Code", "Description"],
                  postProcessCallback: this.GLChartEntryPostProcess,

                  // allowGrouping: false,
                  // postProcessCallback: this.PostProcess,

                  localDataList: true,
                  items: this.glEntryLocalItems,
                },
                columns: this.getGLChartEntryColumns,
              },
            ],
            // options: {
            //   // keyboardNavigation: {
            //   //   enabled: this.dataViewType == "product-list",
            //   //   key: "ProductCode",
            //   //   // }
            //   // },
            //   // focusedRowEnabled: this.dataViewType == "product-list",
            //   // showColumnLines: this.dataViewType == "product-list",

            //   // keyboardNavigation: {
            //   //   enabled: true, //this.dataViewType == "product-list",
            //   //   key:
            //   //     this.dataViewType == "product-list"
            //   //       ? "ProductCode"
            //   //       : this.dataViewType == "review"
            //   //       ? "Code"
            //   //       : "Code",
            //   //   // customKey: (type) => {
            //   //   //   if(type == "product-list") return "ProductCode";
            //   //   //   else return "Code";
            //   //   // }
            //   // },
            //   // focusedRowEnabled: true, // this.dataViewType == "product-list",
            //   // showColumnLines: true, //this.dataViewType == "product-list",
            //   // wordWrapEnabled: false,
            //   // selectionMode: 'none'
            // },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
            addNew: this.dataViewType == "general-ledger-entry",
            addNewCallBack: this.addNewItemToList,
          },
          columns: [
            {
              screenField: "Item",
            },
            {
              screenField: "Branch",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "BranchCode",
              listner: (e, lineData) => {
                lineData.data.BranchCode = e.itemData.Code;
                lineData.data.BranchDescription = e.itemData.Description;

                this.checkMultipleBranchDivision();
              },
            },
            {
              dataField: "DivisionCode",
              listner: (e, lineData) => {
                lineData.data.DivisionCode = e.itemData.Code;
                lineData.data.DivisionDescription = e.itemData.Description;

                this.checkMultipleBranchDivision();
              },
            },
            {
              dataField: "TaxCode",
              listner: (e, lineData) => {
                lineData.data.TaxCode = e.itemData.Code;
                lineData.data.TaxPcnt = e.itemData.Rate;
                this.footerValueCalculations(lineData);
              },
            },
            {
              dataField: "RequiredByDate",
              listner: (e, lineData) => {
                lineData.data.RequiredByDate = e.value;
                lineData.data.ETADate = e.value;
              },
            },
            {
              dataField: "ETADate",
              listner: (e, lineData) => {
                lineData.data.ETADate = e.value;
              },
            },
            {
              dataField: "SupplierRequired",
              listner: (e, lineData) => {
                lineData.data.SupplierRequired = e.value;
                if (lineData.data.SupplierPrice)
                  lineData.data.SupplierFXPrice = lineData.data.SupplierPrice;

                this.footerValueCalculations(lineData);

                if (lineData.data.SupplierReceivedQty > e.value) {
                  let msgObj = {
                    Code: lineData.data.Code,
                    Description: lineData.data.Description,
                    RequiredQty: e.value,
                    ReceivedQty: lineData.data.SupplierReceivedQty,
                  };
                  const getindex = this.brokenGridValidations.findIndex(
                    (x) =>
                      x.Code === lineData.data.Code &&
                      x.CopyCode == lineData.data.CopyCode
                  );
                  if (getindex > -1) {
                    // this.brokenGridValidations[getindex] = msgObj;
                    this.addInToGridValidations(getindex, msgObj);
                  } else {
                    // this.brokenGridValidations.push(msgObj);
                    this.pushInTOGridValidations(msgObj);
                  }

                  this.addToValidationSum(
                    `Item : ${
                      lineData.data.ItemDescription
                    } has a required quantity of ${this.formatNumber(
                      e.value
                    )} which is below the received quantity of ${this.formatNumber(
                      lineData.data.SupplierReceivedQty
                    )}.`
                  );
                } else {
                  const getindex = this.brokenGridValidations.findIndex(
                    (x) =>
                      x.Code === lineData.data.Code &&
                      x.CopyCode == lineData.data.CopyCode
                  );
                  if (getindex > -1) {
                    // this.brokenGridValidations.splice(getindex, 1);
                    this.removeFromGridValidations(getindex);
                  }
                }

                var index = this.reviewDataSource.findIndex(
                  (x) =>
                    x.Code == lineData.data.Code &&
                    x.CopyCode == lineData.data.CopyCode
                );
                if (e.value == 0) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                } else {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  this.addToReview(lineData.data);
                  this.setLineNo();
                }
              },
            },
            {
              dataField: "SupplierFXPrice",
              listner: (e, lineData) => {
                lineData.data.SupplierFXPrice = e.value;
                this.footerValueCalculations(lineData);
              },
            },
            {
              dataField: "Comment",
              listner: (e, lineData) => {
                if (e.value.length >= 1000) {
                  this.addToValidationSum(
                    "comments only allow maximum length of 1000 characters"
                  );
                  lineData.data.Comment = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                } else lineData.data.Comment = e.value;
                var index = this.reviewDataSource.findIndex(
                  (x) =>
                    x.Code == lineData.data.Code &&
                    x.CopyCode == lineData.data.CopyCode
                );
                if (e.value) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  this.addToReview(lineData.data);
                }
                // this.footerValueCalculations(lineData);
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData) => {
                this.deleteRow(e, lineData);
              },
            },
            {
              dataField: "ActionCopy",
              listner: (e, lineData) => {
                this.copyRow(e, lineData);
              },
            },
            {
              dataField: this.getAccountSort("SortAccountBy").dataField,
              listner: (e, lineData) => {
                let index = this.reviewDataSource.findIndex(
                  (x) =>
                    x.ItemCode == lineData.data.Code &&
                    x.CopyCode == lineData.data.CopyCode
                );
                if (index != -1) {
                  // this.reviewDataSource.splice(index, 1);
                  this.removeFromReview(index);
                }

                // let index2 = undefined;
                // if (this.dataViewType == "general-ledger-entry") {
                //   index2 = this.glEntryLocalItems.findIndex((x) => {
                //     if (x.PurchaseOrderCode) {
                //       return x.ItemCode == lineData.data.Code;
                //     } else return x.CopyCode == lineData.data.CopyCode;
                //   });
                //   // if (index2 != -1) this.removeFromGLEntry(index2);
                // }
                var data = this.glEntryLocalItems.filter(
                  (x) => x.ItemCode == e.itemData.ComputedStringCode
                );
                // e.component.beginUpdate();
                // e.component.option("value", e.itemData.ComputedStringCode);
                // e.component.endUpdate();
                lineData.data.CopyCode =
                  e.itemData.ComputedStringCode + "-" + data.length;

                lineData.data[this.getAccountSort("SortAccountBy").dataField] =
                  e.itemData.ComputedStringCode;
                lineData.data.Code = e.itemData.ComputedStringCode;
                lineData.data.Description = e.itemData.Description;
                lineData.data.ItemCode = e.itemData.ComputedStringCode;
                lineData.data.ItemDescription = e.itemData.Description;

                lineData.data.BranchCode = this.defaultDataModel.DefaultBranchCode;
                lineData.data.BranchDescription = this.defaultDataModel.DefaultBranchDescription;
                lineData.data.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
                lineData.data.DivisionDescription = this.defaultDataModel.DefaultDivisionDescription;
                lineData.data.RequiredByDate = new Date();
                lineData.data.ETADate = this.defaultDataModel.ETADate
                  ? this.defaultDataModel.ETADate
                  : new Date();
                lineData.data.SupplierUM = "Ea";

                lineData.data.TaxCode =
                  this.model.CurrencyCode == "AUD" ? "G" : "E";

                var tax = this.taxCodeDataSourceItems.filter(
                  (t) => t.Code == lineData.data.TaxCode
                );
                if (tax.length > 0) lineData.data.TaxPcnt = tax[0].Rate;

                if (index != -1) this.addToReview(lineData.data);

                // if (this.dataViewType == "general-ledger-entry") {
                //   if (index2 != -1) this.pushIntoGLEntry(lineData.data);
                // }
              },
            },
          ],
          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "Comment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      height: "140",
                      maxLength: 1000,
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
          },
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              value: 0,
            },
            {
              dataField: "FXLineTotal",
              screenField: "TaxableFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Sub Total (${this.model.CurrencyCode})`,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Tax (${this.model.CurrencyCode})`,
            },
            {
              screenField: "FXTotal",
              dataField: "TotalWithTax",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Total (${this.model.CurrencyCode})`,
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  label: {
                    text: "Name",
                  },
                  editorOptions: {
                    maxLength: "100",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "DeliveryAddressStreetLine1",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "DeliveryAddressStreetLine2",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressSuburb",
                  dataField: "DeliveryAddressSuburb",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressState",
                  dataField: "DeliveryAddressState",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressPostcode",
                  dataField: "DeliveryAddressPostcode",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressCountry",
                  dataField: "DeliveryAddressCountry",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" ||
                      this.model.Status === "X" ||
                      (this.model.Status === "A" && this.model.GoodsIn),
                  },
                  // allowUpdate: false,
                },
              ],
            },
          ],
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        value:
                          this.baseView.mode != "review"
                            ? new Date()
                            : undefined,
                      },
                      required: this.baseView.mode != "review",
                    },
                    // {
                    //   dataField: "NextStatus",
                    //   gcLabel: "Next Status",
                    //   gcType: "String",
                    //   editorType: "dxSelectBox",
                    //   required: true,
                    //   editorOptions: {
                    //     readOnly:
                    //       this.model.Status === "C" ||
                    //       this.model.Status === "X",
                    //     items: this.getNextStatus,
                    //     valueExpr: "id",
                    //     displayExpr: "text",
                    //   },
                    // },
                    {
                      screenField: "SupplierRef",
                      editorOptions: {
                        maxLength: 20,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    // {
                    //   dataField: "DeliveryAddressCompanyName",
                    //   label: {
                    //     text: "Deliver To",
                    //   },
                    //   editorType: "dxTextBox",
                    //   editorOptions: {
                    //     maxLength: "100",
                    //     readOnly:
                    //       this.model.Status === "C" ||
                    //       this.model.Status === "X" ||
                    //       (this.model.Status === "A" && this.model.GoodsIn),
                    //   },
                    // },
                    {
                      screenField: "DeliverToBranch",
                      dataField:
                        this.baseView.mode == "create"
                          ? "DeliverTo"
                          : "DeliveryAddressCompanyName",

                      onItemClick: this.setDeliverTo,
                      ref: "DeliveryAddressCompanyName",
                      // displayExpr: () => {
                      //   return this.model.DeliveryAddressCompanyName;
                      // },
                      displayExpr: "Description",
                      acceptCustomValue: true,
                      onCustomItemCreating: (data) => {
                        if (!data.text) {
                          return;
                        } else {
                          this.deliverToCustomItem(data);
                        }
                      },
                    },
                    {
                      screenField: "DeliveryCompanyView",
                      editAddress:
                        this.baseView.mode != "review" ? true : false,
                    },
                    {
                      screenField: "Currency",
                      allowUpdate: false,
                    },
                    {
                      screenField: "ExchangeRate",
                      editorOptions: {
                        readOnly:
                          this.model.CompanyCurrency ===
                            this.model.CurrencyCode ||
                          this.model.Status === "C" ||
                          this.model.Status === "X" ||
                          this.model.GoodsIn,
                      },
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: (e) => {
                            e.rule.message = `You have entered an exchange rate of ${formatNumber(
                              e.value,
                              e.formItem.editorOptions.format
                            )}, which is invalid. Please enter an exchange rate that is greater than 0.0000`;

                            return e.value > 0;
                          },
                        },
                      ],
                      // allowUpdate: false,
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      label: {
                        text: "Branch",
                      },
                      dataField: "BranchCode",
                      editorOptions: {
                        onItemClick: this.onBranchCodeValueChanged.bind(this),
                        placeholder: this.branchPlaceHolder,
                        elementAttr: {
                          class:
                            this.branchPlaceHolder != "Select"
                              ? "class-multiple"
                              : "class-name",
                        },
                      },
                    },
                    {
                      screenField: "Division",
                      label: {
                        text: "Division",
                      },
                      dataField: "DivisionCode",
                      editorOptions: {
                        onItemClick: this.onDivisionCodeValueChanged.bind(this),
                        placeholder: this.divisionPlaceHolder,
                        elementAttr: {
                          class:
                            this.divisionPlaceHolder != "Select"
                              ? "class-multiple"
                              : "class-name",
                        },
                      },
                    },
                    {
                      screenField: "ETADate",
                      label: {
                        text: "ETA",
                      },
                      dataField: "ETA",
                      editorOptions: {
                        min: new Date(),
                        onValueChanged: this.onETAValueChanged.bind(this),
                      },
                      visible: this.baseView.mode != "create",
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode != "create" ? "Code" : undefined,
                text:
                  this.baseView.mode != "create"
                    ? "Purchase Order # "
                    : "Create Purchase Order",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField:
                this.baseView.mode != "create" ? "SupplierName" : undefined,
              text: undefined,
            },
          },
        },
      };
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Purchase Orders Review",
          email: this.baseView.mode == "review",
          audit: this.baseView.mode == "review",
          editURL: "/purchase-order",
          status: true,
          notes: true,
          pdf: this.baseView.mode == "review",
          //  copy: this.baseView.mode == "review",
          //  copyCallBack: this.copyPurchaseOrder,
          save: this.model.Status !== "C" && this.model.Status !== "X",
          saveKey: true,
          saveOptions: {
            items: [
              { text: "Draft", value: "D", disabled: this.model.Status == "A" },
              { text: "Save", value: "A", default: true },
            ],
            keyExpr: "value",
            displayExpr: "text",
            dropDownOptions: {
              width: "100px",
            },
            saveKey: "NextStatus",
          },
          saveCallback: this.saveData,
          commentsTitle: "Purchase Order Comments",
          toolbarFormItems: [
            {
              screenField: "Supplier",
              dataField: "SupplierCode",
              cssClass: "toolbar-customer-label",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                },
                width: 300,
                placeholder: "Supplier Name",
                // onValueChanged: this.onSupplierCodeValueChanged2.bind(this),
                showClearButton: true,
                onItemClick: this.onSupplierCodeValueChanged.bind(this),
              },
              label: {
                text: "Supplier",
                visible: false,
              },
              required: true,
            },
            // },
          ],
          // toolbarAfterFormItems: [
          //   {
          //     screenField: "Inactive",
          //     dataField: "GoodsReceived",
          //     editorType: "dxSwitch",
          //     label: {
          //       text: "Goods Received",
          //     },
          //   },
          // ],

          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
          emailMenuItems: {
            referenceNoField: "Code",
            makeDisabled: (dataModel, emailRecords) => {
              var items = [];

              emailRecords.forEach((element) => {
                items.push({
                  ReportDisplayName: element.ReportDisplayName,
                  ScreenName: element.ScreenName,
                  ScreenLayoutApplicationFeatureCode:
                    element.ScreenLayoutApplicationFeatureCode,
                  TransactionCode: element.TransactionCode,
                  disabled: element.disabled,
                });
              });

              return items;
            },
          },
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          orderComments: {
            dataField: "SalesOrderTypeCode",
            endpoint: "SalesOrderType",
            toMatch: [
              "UserComment1",
              "UserComment2",
              "UserComment3",
              "UserComment4",
              "UserComment5",
              "UserComment6",
              "UserComment7",
              "UserComment8",
              "UserComment9",
              "UserComment10",
              "UserComment11",
              "UserComment12",
              "UserComment13",
              "UserComment14",
              "UserComment15",
              "UserComment16",
              "UserComment17",
              "UserComment18",
              "UserComment19",
              "UserComment20",
            ],
          },
          commentItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "DeliveryInstruction1",
                  label: { text: "Delivery 1" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "DeliveryInstruction2",
                  label: { text: "Delivery 2" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "Comment1",
                  label: { text: "Comment 1" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "Comment2",
                  label: { text: "Comment 2" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "Comment3",
                  label: { text: "Comment 3" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "Comment4",
                  label: { text: "Comment 4" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "Comment5",
                  label: { text: "Comment 5" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
              ],
            },
          ],

          ellipsis: {
            menuItems: this.cancelCompleteMenu,
            visible: this.baseView.mode == "review",
            clickAction: (e) => {
              if (e.itemData.menuText == "Cancel Order") {
                this.cancelOrder();
              } else {
                this.completeOrder();
              }
            },
            disabled:
              !FeatureStorage.checkPermission("PurchaseOrder", "create") ||
              this.cancelCompleteMenu.length == 0,
          },
        },
      };
    },
    getProductColumns() {
      var columns = [
        {
          screenField: "Product",
          sortOrder: this.getProductSort("SortProductBy").sortOrder,
          gridDataField: this.getProductSort("SortProductBy").dataField,
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          width: "auto",
          cellTemplateRecord: {
            image: {
              codeDataField: "ProductCode",
              descriptionDataField: "PurchaseDescription1",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField: "PurchaseDescription1",
              },
            ],
            secondary: [
              {
                dataField: "ProductCode",
              },
            ],
          },
          exportFields: [
            {
              dataField: "ProductCode",
              label: "Product Code",
            },
            {
              dataField: "PurchaseDescription1",
              label: "Purchase Description 1",
            },
          ],
        },
      ];

      var cols = [...this.getCommonColumns];
      cols.splice(4, 0, {
        screenField: "TaxCode",
        label: "Tax",
        cellTemplate: this.getGLTaxCodeCellTemplate,
        dataSourceConfig: {
          data: this.taxCodeDataSourceItems,
        },
        valueExpr: "Code",
        displayExpr: "Code",
        allowSearch: this.dataViewType == "review" ? true : false,
        allowSorting: this.dataViewType == "review" ? true : false,
        allowFiltering: false,

        width: ColumnWidth.TaxCode.width,
        minWidth: ColumnWidth.TaxCode.minWidth,
        dropDownOptions: {
          width: 150,
        },
        makeReadOnly: (data) => {
          if (this.baseView.mode == "review") return true;
          if (data.data.ItemType == "S") return true;
          else return this.model.CurrencyCode != "AUD" ? true : false;
        },
      });
      return columns.concat(cols);
    },
    getReviewColumns() {
      var columns = [
        {
          screenField:
            this.dataViewType == "general-ledger-entry" ? "GLChart" : "Item",
          label: "Product/Account",
          gridDataField: this.getAccountSort("SortAccountBy").dataField,
          sortOrder: this.getAccountSort("SortAccountBy").sortOrder,
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          cellTemplateRecord: {
            image: {
              codeDataField: "ProductCode",
              descriptionDataField:
                this.baseView.mode === "review"
                  ? "Description"
                  : "PurchaseDescription",
              // this.baseView.mode == "review"
              //   ? "PurchaseDescription"
              //   : "PurchaseDescription1",
              hasPrimaryImageDataField: "HasPrimaryImage",
            },
            primary: [
              {
                dataField:
                  this.baseView.mode === "review"
                    ? "Description"
                    : "PurchaseDescription",
                // this.baseView.mode == "review"
                //   ? "PurchaseDescription"
                //   : "PurchaseDescription1",
              },
            ],
            secondary: [
              {
                dataField: "ProductCode",
              },
            ],
          },
          exportFields: [
            {
              dataField:
                this.dataViewType == "review" ? "Code" : "ComputedStringCode",
              label: "Item Code",
            },
            {
              // dataField: "Description",
              dataField:
                this.baseView.mode === "review"
                  ? "Description"
                  : "PurchaseDescription",
              // this.baseView.mode == "review"
              //   ? "PurchaseDescription"
              //   : "PurchaseDescription1",
              label: "Item Description",
            },
          ],
          width: "auto",

          cellTemplate:
            this.dataViewType == "general-ledger-entry"
              ? "SelectField"
              : "Record",

          dataSourceConfig: {
            // endpoint: "api/GLChart",
            // sort: {
            //   selector: "Description",
            //   asc: true,
            // },
            // filter: this.gLChartDataSourceFilter(),
            data: this.glChartDataSourceItems,
          },
        },
      ];
      var cols = [...this.getCommonColumns];
      cols.splice(2, 0, {
        screenField: "TaxCode",
        label: "Tax",
        cellTemplate: this.getGLTaxCodeCellTemplate,
        dataSourceConfig: {
          data: this.taxCodeDataSourceItems,
        },
        valueExpr: "Code",
        displayExpr: "Code",
        allowSearch: this.dataViewType == "review" ? true : false,
        allowSorting: this.dataViewType == "review" ? true : false,
        allowFiltering: false,
        width: ColumnWidth.TaxCode.width,
        minWidth: ColumnWidth.TaxCode.minWidth,
        dropDownOptions: {
          width: 150,
        },
        makeReadOnly: (data) => {
          if (this.baseView.mode == "review") return true;
          if (data.data.ItemType == "S") return true;
          else return this.model.CurrencyCode != "AUD" ? true : false;
        },
      });
      return columns.concat(cols);
    },
    getGLChartColumns() {
      var columns = [
        {
          screenField: "Item",
          label: "Product/Account",
          gridDataField: this.getAccountSort("SortAccountBy").dataField,
          // sortOrder: this.getAccountSort("SortAccountBy").sortOrder,
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          exportFields: [
            {
              dataField:
                this.dataViewType == "review" ? "Code" : "ComputedStringCode",
              label: "Item Code",
            },
            {
              dataField: "Description",
              label: "Item Description",
            },
          ],
          width: "auto",

          cellTemplate: "Record",

          // dataSourceConfig: {
          //   // endpoint: "api/GLChart",
          //   // sort: {
          //   //   selector: "Description",
          //   //   asc: true,
          //   // },
          //   // filter: this.gLChartDataSourceFilter(),
          //   data: this.glChartDataSourceItems,
          // },
        },
      ];

      var cols = [...this.getCommonColumns];
      cols.splice(2, 0, {
        screenField: "TaxCode",
        label: "Tax",
        cellTemplate: this.getGLTaxCodeCellTemplate,
        dataSourceConfig: {
          data: this.taxCodeDataSourceItems,
        },
        valueExpr: "Code",
        displayExpr: "Code",
        allowSearch: this.dataViewType == "review" ? true : false,
        allowSorting: this.dataViewType == "review" ? true : false,
        allowFiltering: false,
        // fieldTemplate: true,
        displayValue: (data) => {
          return data ? data.TaxCode : "";
        },
        width: ColumnWidth.TaxCode.width,
        minWidth: ColumnWidth.TaxCode.minWidth,
        dropDownOptions: {
          width: 150,
        },
        // readOnly:true,
        // readOnly: this.model.CurrencyCode != "AUD",
        makeReadOnly: (data) => {
          if (this.baseView.mode == "review") return true;
          if (data.data.ItemType == "S") return true;
          else return this.model.CurrencyCode != "AUD" ? true : false;
        },
      });
      return columns.concat(cols);
    },
    getGLChartEntryColumns() {
      var columns = [
        {
          screenField: "GLChart",
          label: "Product/Account",
          gridDataField: this.getAccountSort("SortAccountBy").dataField,
          // sortOrder: this.getAccountSort("SortAccountBy").sortOrder,
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          exportFields: [
            {
              dataField:
                this.dataViewType == "review" ? "Code" : "ComputedStringCode",
              label: "Item Code",
            },
            {
              dataField: "Description",
              label: "Item Description",
            },
          ],
          width: "auto",

          cellTemplate: "SelectField",

          dataSourceConfig: {
            data: this.glChartDataSourceItems,
          },
        },
      ];

      var cols = [...this.getCommonColumns];
      cols.splice(2, 0, {
        screenField: "TaxCode",
        label: "Tax",
        cellTemplate: this.getGLTaxCodeCellTemplate,
        dataSourceConfig: {
          data: this.taxCodeDataSourceItems,
        },
        valueExpr: "Code",
        displayExpr: "Code",
        allowSearch: this.dataViewType == "review" ? true : false,
        allowSorting: this.dataViewType == "review" ? true : false,
        allowFiltering: false,
        // fieldTemplate: true,
        displayValue: (data) => {
          return data ? data.TaxCode : "";
        },
        width: 80,
        minWidth: 80,
        dropDownOptions: {
          width: 150,
        },
        // readOnly:true,
        // readOnly: this.model.CurrencyCode != "AUD",
        makeReadOnly: (data) => {
          if (this.baseView.mode == "review") return true;
          if (data.data.ItemType == "S") return true;
          else return this.model.CurrencyCode != "AUD" ? true : false;
        },
      });
      return columns.concat(cols);
    },
    getCommonColumns() {
      return [
        {
          screenField: "Branch",
          cellTemplate: "SelectField",
          gridDataField: "BranchCode",
          dataSourceConfig: {
            data: this.branchDataSourceItems,
          },
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          // fixed: true,
          // fixedPosition: "left",
          required: true,
          displayValue: (data) => {
            return data.Code;
          },
          // fieldTemplate: true,
          displayExpr: "Code",
          searchExpr: ["Code", "Description"],
          editorTemplate: {
            primary: [
              {
                dataField: "Code",
              },
            ],
            secondary: [
              {
                dataField: "Description",
              },
            ],
          },
          width: 85,
          minWidth: 85,
          allowUpdate: true,
          dropDownOptions: {
            width: 250,
          },
          visible: this.getColumnVisible("DisplayBranchInDetail"),
        },
        {
          screenField: "Division",
          cellTemplate: "SelectField",
          gridDataField: "DivisionCode",
          dataSourceConfig: {
            data: this.divisionDataSourceItems,
          },
          allowSearch: this.dataViewType == "review",
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          // fixed: true,
          // fixedPosition: "left",
          displayValue: (data) => {
            return data.Code;
          },
          // fieldTemplate: true,
          displayExpr: "Code",
          searchExpr: ["Code", "Description"],
          editorTemplate: {
            primary: [
              {
                dataField: "Code",
              },
            ],
            secondary: [
              {
                dataField: "Description",
              },
            ],
          },
          width: 85,
          minWidth: 85,
          dropDownOptions: {
            width: 250,
          },
          visible: this.getColumnVisible("DisplayDivisionInDetail"),
        },
        {
          screenField: "RequiredDate",
          label: "Required By",
          dataField: "RequiredByDate",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          cellTemplate: "Date",
          minWidth: 150,
          editable: true,
        },
        {
          screenField: "ETADate",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          cellTemplate: "Date",
          minWidth: 150,
          editable: true,
          visible: this.baseView.mode != "create",
        },
        {
          screenField: "SalesUM",
          dataField: "SupplierUM",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          width: 80,
          minWidth: 80,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierRequired",
          type: "EditableDecimal",
          format: "Decimal-16-2",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          width: 110,
          minWidth: 110,
          minmax: { max: 999999.0 },
          allowEditing: this.dataViewType != "review",
        },
        {
          screenField: "Quantity",
          dataField: "SupplierReceivedQty",
          label: "Received",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          format: "Decimal-16-2",
          minWidth: 150,
          visible: this.baseView.mode != "create",
          // allowEditing: this.dataViewType != "review",
        },
        {
          screenField: "FXLineTotal",
          label: `Price(${this.model.CurrencyCode})`,
          dataField: "SupplierFXPrice",
          type: "EditableDecimal",
          format: "Decimal-16-4C",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          minWidth: 150,
          allowEditing: this.dataViewType != "review",
        },
        {
          screenField: "FXLineTotal",
          label: `Total(${this.model.CurrencyCode})`,
          dataField: "FXLineTotal",
          format: "Decimal-16-2C",
          allowSearch: false,
          allowSorting: this.dataViewType == "review",
          allowFiltering: false,
          minWidth: 170,
        },
        {
          screenField: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: false,
          minWidth: 250,
          editCellTemplate: "EditableTextArea",
          allowEditing: this.dataViewType != "review",
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
        },
        {
          dataField: "ActionCopy",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionCopy",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
          makeDisabled: (data) => {
            if (!data.data.Code) return true;
            else return false;
          },
        },
        // {
        //   screenField: "GridRecordEllipsisMenu",
        //   allowEditing: false,
        //   allowSearch: false,
        //   showInColumnChooser: false,
        //   allowSorting: false,
        //   cssClass: "padding-7",
        // },
      ];
    },

    getNextStatus() {
      let items = [];
      if (this.model.Status == "N") {
        items = [
          { text: "Draft", id: "D" },
          { text: "Pending", id: "P" },
          { text: "Active", id: "A" },
        ];
      } else if (this.model.Status == "D" || this.model.Status == "P") {
        items = [
          { text: "Draft", id: "D" },
          { text: "Pending", id: "P" },
          { text: "Active", id: "A" },
          { text: "Cancelled", id: "X" },
        ];
      } else if (this.model.Status == "A") {
        if (this.model.GoodsIn) {
          items = [
            { text: "Active", id: "A" },
            { text: "Completed", id: "C" },
            { text: "Cancelled", id: "X" },
          ];
        } else {
          items = [
            { text: "Draft", id: "D" },
            { text: "Pending", id: "P" },
            { text: "Active", id: "A" },
            { text: "Cancelled", id: "X" },
            { text: "Completed", id: "C" },
          ];
        }
      }
      return items;
    },

    getTotalQty() {
      let total = 0;

      this.reviewDataSource.forEach((element) => {
        total += parseFloat(element.SupplierRequired).roundNumber(4);
      });

      return total;
    },
    getGLTaxCodeCellTemplate() {
      if (this.baseView.mode == "review" || this.model.CurrencyCode != "AUD") {
        return undefined;
      }
      return "SelectField";
    },
  },
  beforeCreate() {
    this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  },
  methods: {
    pushIntoGLEntry(item) {
      this.glEntryLocalItems.push(item);
    },
    removeFromGLEntry(index) {
      this.glEntryLocalItems.splice(index, 1);
    },
    async setGLChartDataSourceItems() {
      let glChartDS = ProductService.dataSourceConfig("api/GLChart", {
        filter: this.gLChartDataSourceFilter(),
        sort: [{ selector: "ComputedStringCode", asc: true }],
        preventPagination: true,
      });

      this.glChartDataSourceItems = await glChartDS.load();
      this.glChartDataSourceItems2 = [
        ...this.GLChartPostProcess(this.glChartDataSourceItems),
      ];
    },
    addNewItemToList() {
      if (this.dataViewType == "general-ledger-entry") {
        let dataObj = Object.assign(
          { IsGLEntry: true },
          {
            Code: undefined,
            Description: undefined,
            Inactive: "N",
            BranchCode: undefined,
            BranchDescription: undefined,
            DivisionCode: undefined,
            DivisionDescription: undefined,
            RequiredByDate: undefined,
            ETADate: undefined,
            SupplierUM: undefined,
            SupplierRequired: 0,
            SupplierReceivedQty: 0,
            IsBatchProduct: "No",
            SupplierFXPrice: 0,
            FXLineTotal: 0,
            ItemCode: undefined,
            ItemDescription: undefined,
            ItemType: "G",
            TaxableFXLineTotal: 0,
            TaxFXLineTotal: 0,
            FXTotal: 0,
            TotalWithTax: 0,
            LineNo: 0,
            SupplierConversion: 1,
            SupplierPrice: 0,
            TaxPcnt: 0,
            IsVariable: "N",
            IsCopyLine: false,
            // CopyCode: undefined,
            TaxCode: undefined,
            Comment: "",
            IsGLEntry: true,
          }
        );
        // this.glEntryLocalItems.push({ ...dataObj });
        // this.glEntryLocalItems = this.glEntryLocalItems.concat([
        //   { ...dataObj },
        // ]);
        this.glEntryLocalItems.splice(this.glEntryLocalItems.length, 0, {
          ...dataObj,
        });

        setTimeout(() => {
          this.$refs["purchase-order"].$refs["transactionGrid"].reSizeGrid();
        }, 500);
      }
    },
    copyRow(e, lineData) {
      if (this.dataViewType == "general-ledger-entry") {
        if (!lineData.data.Code) {
          this.addToValidationSum("Product can not be empty");
          return;
        }
      }
      var items = this.$refs["purchase-order"].$refs[
        "transactionGrid"
      ].getDataSource();

      let dataObj = Object.assign({ IsCopyLine: true }, lineData.data);
      dataObj.IsCopyLine = true;
      dataObj.LineNo = 0;

      var data = items.filter((x) => x.ItemCode == dataObj.ItemCode);
      dataObj.CopyCode = dataObj.ItemCode + "-" + data.length;

      // items.splice(lineData.rowIndex + 1, 0 , dataObj);

      if (this.dataViewType == "general-ledger-entry") {
        this.glEntryLocalItems.push({ ...dataObj });
      }
      this.addToReview({ ...dataObj });

      this.$refs["purchase-order"].$refs["transactionGrid"].gridRepaint();
    },
    handleLocalRouteChange() {
      if (this.baseView.mode == "edit") {
        this.reload = true;
        setTimeout(() => {
          this.reload = false;
        }, 250);
      }
    },
    checkMultipleBranchDivision() {
      var items = this.$refs["purchase-order"].$refs[
        "transactionGrid"
      ].getDataSource();
      var branchCode,
        divisionCode = undefined;
      items.forEach((item) => {
        if (branchCode) {
          if (branchCode != item.BranchCode) {
            this.model.BranchCode = undefined;
            this.branchPlaceHolder = "Multiple entries specified";
          }
        } else {
          branchCode = item.BranchCode;
          this.model.BranchCode = item.BranchCode;
          this.branchPlaceHolder = "Select";
        }

        if (divisionCode) {
          if (divisionCode != item.DivisionCode) {
            this.model.DivisionCode = undefined;
            this.divisionPlaceHolder = "Multiple entries specified";
          }
        } else {
          divisionCode = item.DivisionCode;
          this.model.DivisionCode = item.DivisionCode;
        }
      });
    },
    async deleteRow(e, lineData) {
      let confirmLeaving = await this.$confirm(
        "Are you sure you want to delete this record ?",
        "Delete Record"
      );

      if (confirmLeaving) {
        if (this.dataViewType == "review") {
          let dIndex = undefined;
          if (lineData.data.IsCopyLine) {
            dIndex = this.reviewDataSource.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
          } else {
            dIndex = this.reviewDataSource.findIndex(
              (x) => x.Code == lineData.data.Code
            );
          }
          if (dIndex > -1 && this.reviewDataSource[dIndex].PurchaseOrderCode) {
            let glIndex = this.glEntryLocalItems.findIndex(
              (x) =>
                x.ItemCode == lineData.data.ItemCode &&
                lineData.data.PurchaseOrderCode
            );
            this.glEntryLocalItems.splice(glIndex, 1);
          }
          if (dIndex != -1) this.removeFromReview(dIndex);
          if (lineData.data.IsGLEntry) {
            var index = this.glEntryLocalItems.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
            this.glEntryLocalItems.splice(index, 1);
          }
        } else {
          let index = undefined;

          if (
            this.dataViewType == "general-ledger-entry" &&
            !lineData.data.IsCopyLine
          ) {
            index = this.reviewDataSource.findIndex(
              (x) => x.ItemCode == lineData.data.ItemCode
            );
            if (index > -1 && this.reviewDataSource[index].PurchaseOrderCode) {
              let glIndex = this.glEntryLocalItems.findIndex(
                (x) =>
                  x.ItemCode == lineData.data.ItemCode &&
                  lineData.data.PurchaseOrderCode
              );
              this.glEntryLocalItems.splice(glIndex, 1);
              this.removeFromReview(index);
            } else {
              let glIndex = this.glEntryLocalItems.findIndex(
                (x) => x.ItemCode == lineData.data.ItemCode
              );
              this.glEntryLocalItems.splice(glIndex, 1);
              this.removeFromReview(index);
            }
          } else if (!lineData.data.IsCopyLine) {
            lineData.data.SupplierRequired = 0;
            lineData.data.SupplierFXPrice = 0;
            lineData.data.Comment = "";
            this.footerValueCalculations(lineData);
            index = this.reviewDataSource.findIndex(
              (x) => x.ItemCode == lineData.data.ItemCode
            );

            this.removeFromReview(index);
          } else {
            if (
              this.dataViewType == "general-ledger-entry" &&
              lineData.data.IsCopyLine
            ) {
              let glIndex = this.glEntryLocalItems.findIndex(
                (x) => x.ItemCode == lineData.data.ItemCode
              );
              this.glEntryLocalItems.splice(glIndex, 1);
            }

            let index2 = this.reviewDataSource.findIndex(
              (x) => x.CopyCode == lineData.data.CopyCode
            );
            this.removeFromReview(index2);
            this.$refs["purchase-order"].$refs["transactionGrid"].gridRepaint();
          }
        }
      }
    },
    async completeOrder() {
      let confirmcompletel = await this.$confirm(
        "Do you want to complete this order?",
        "Complete Order"
      );

      if (confirmcompletel) {
        this.setLoading = true;

        let payload = {
          DateIn: this.model.DateIn
            ? this.model.DateIn.toSaveDate()
            : this.model.DateIn,
          DateReceived: new Date().toSaveDate(),
          SupplierCode: this.model.SupplierCode,
          GoodsInDetails: [],
        };

        this.reviewDataSource.forEach((el) => {
          let obj = {
            ActualStockConversion: el.SupplierConversion,
            Comment: el.Comment,
            IsVariable: el.IsVariable,
            ItemCode: el.ItemCode,
            LineComplete: "Y",
            PurchaseOrderCode: el.PurchaseOrderCode,
            PurchaseOrderComment: el.Comment,
            PurchaseOrderLineNo: el.LineNo,
            ReceivedQty: el.SupplierOutstandingQuantity * el.SupplierConversion,
            StandardStockConversion: el.SupplierConversion,
            SupplierReceivedQty: el.SupplierOutstandingQuantity,
            // GoodsInProductBatches: [],
          };
          payload.GoodsInDetails.push(obj);
        });

        await GoodsInService.saveGoodsIn(payload)
          .then((res) => {
            if (res) this.setLoading = false;
            this.$notify(
              `Successfully completed the PO #${this.baseView.id}`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.reload = true;
            this.loaded = false;
            this.beforeInit();
          })
          .catch((error) => {
            this.setLoading = false;
            this.serverError = {
              err: error,
              msg: "PO failed to complete",
              time: new Date().getTime(),
            };
          });
      }
    },
    async cancelOrder() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this order?",
        "Cancel Order"
      );

      if (confirmCancel) {
        this.model.NextStatus = "X";
        this.saveOrder();
      }
    },
    async beforeInit() {
      this.$store.dispatch("dataContext/setReviewDataSource", []);
      this.$store.dispatch("dataContext/setSearchText", undefined);

      this.glEntryLocalItems = [];
      await SettingsService.getBySettingByApplicationFeatureCode(
        "PurchaseOrder"
      ).then((res) => {
        this.screenSettings = res.data.value;
      });

      if (this.baseView.mode !== "create") {
        await PurchaseOrder.getCustomData({
          url: "PurchaseOrderList",
          filter: `Code eq ${this.baseView.id} and (Status ne 'C' and Status ne 'X')`,
          select: ["Code", "GoodsReceived", "Status"],
        }).then((res) => {
          if (res.data.value.length > 0) {
            this.cancelCompleteMenu = [
              {
                menuText: "Complete Order",
                visible: res.data.value[0].GoodsReceived == "Y",
              },
              {
                menuText: "Cancel Order",
                visible: res.data.value[0].GoodsReceived == "N",
              },
            ];
          } else this.cancelCompleteMenu = [];
        });
      }

      this.reload = false;
      this.initialized();
    },
    gLChartDataSourceFilter() {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == "FilterAccountType"
      );

      var filter = [["Inactive eq 'N'"]];

      if (data.length > 0) {
        var x = data[0].SettingValue.split(",");
        var fil = [];
        x.forEach((element) => {
          fil.push([`AccountType`, "=", element]);
          fil.push("or");
        });

        if (fil.length > 0) {
          filter.push("and");
          filter.push(fil);
        }
        return filter;
      } else {
        return filter;
      }
    },
    getAccountSort(SortAccountBy) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SortAccountBy
      );

      if (this.dataViewType == "review") {
        return {
          sortOrder: "asc",
          dataField: "PurchaseDescription",
        };
      } else if (data.length > 0) {
        if (data[0].SettingValue == "AccountDescriptionAsc")
          return {
            sortOrder: "asc",
            dataField: "ParentGLChartDescription",
          };
        else if (data[0].SettingValue == "AccountDescriptionDesc")
          return {
            sortOrder: "desc",
            dataField: "ParentGLChartDescription",
          };
        else if (data[0].SettingValue == "AccountCodeAsc")
          return {
            sortOrder: "asc",
            dataField: "ComputedStringCode",
          };
        else if (data[0].SettingValue == "AccountCodeDesc")
          return {
            sortOrder: "desc",
            dataField: "ComputedStringCode",
          };
        else
          return {
            sortOrder: "asc",
            dataField: "ParentGLChartDescription",
          };
      } else
        return {
          sortOrder: "asc",
          dataField: "ParentGLChartDescription",
        };
    },
    getProductSort(SortProductBy) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SortProductBy
      );

      if (data.length > 0) {
        if (data[0].SettingValue == "ProductDescriptionAsc")
          return {
            sortOrder: "asc",
            dataField: "PurchaseDescription1",
          };
        else if (data[0].SettingValue == "ProductDescriptionDesc")
          return {
            sortOrder: "desc",
            dataField: "PurchaseDescription1",
          };
        else if (data[0].SettingValue == "ProductCodeAsc")
          return {
            sortOrder: "asc",
            dataField: "ProductCode",
          };
        else if (data[0].SettingValue == "ProductCodeDesc")
          return {
            sortOrder: "desc",
            dataField: "ProductCode",
          };
        else
          return {
            sortOrder: "asc",
            dataField: "PurchaseDescription1",
          };
      } else
        return {
          sortOrder: "asc",
          dataField: "PurchaseDescription1",
        };
    },
    getColumnVisible(SettingName) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SettingName
      );

      if (data.length > 0) {
        if (data[0].SettingValue == "N") return false;
        else return true;
      } else return true;
    },
    deliverToCustomItem(data) {
      this.model.DeliveryAddressCompanyName = data.text;

      data.customItem = {
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
      };
    },
    setDeliverTo(item, e) {
      item.DeliveryAddressCompanyName = e.itemData.Description;
      item.DeliveryAddressStreetLine1 = e.itemData.PhysicalAddressStreetLine1;
      item.DeliveryAddressStreetLine2 = e.itemData.PhysicalAddressStreetLine2;
      item.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
      item.DeliveryAddressState = e.itemData.PhysicalAddressState;
      item.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
      item.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
      item.DeliverTo = e.itemData.Code;

      if (e.component) {
        var component = e.component.instance();
        component.repaint();
      }
      // item.CustomerDeliveryAddressLineNo = e.itemData.LineNo.toString();
    },
    async onETAValueChanged(e) {
      if (!e.value || !e.event) return;

      let confirmETAChange = await this.$confirm(
        "Changing the ETA will update the ETA for all PO lines except for those that are closed, are you sure you want to continue?",
        "Confirm ETA Change"
      );

      if (confirmETAChange) {
        this.defaultDataModel.ETADate = this.model.ETA;
        this.reviewDataSource.forEach((x) => {
          x.ETADate = this.defaultDataModel.ETADate;
        });

        var grid = this.$refs["purchase-order"].$refs["transactionGrid"];
        grid.gridRepaint();
      } else {
        if (!e.previousValue) this.model.ETA = undefined;
        else this.model.ETA = e.previousValue;

        this.defaultDataModel.ETADate = this.model.ETA;

        e.component.beginUpdate();
        e.component.option("value", this.model.ETA);
        e.component.endUpdate();
      }
    },
    async onDivisionCodeValueChanged(e) {
      let confirmDivisionChange = await this.$confirm(
        "Changing the Division will update the division for all PO lines, are you sure you want to continue?",
        "Confirm Division Change"
      );

      if (confirmDivisionChange) {
        this.divisionPlaceHolder = "Select";
        this.model.DivisionChanged = true;
        this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode;
        this.defaultDataModel.DefaultDivisionDescription =
          e.itemData.Description;

        this.reviewDataSource.forEach((x) => {
          x.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
          x.DivisionDescription = this.defaultDataModel.DefaultDivisionDescription;
        });

        var grid = this.$refs["purchase-order"].$refs["transactionGrid"];
        grid.gridRepaint();
      } else {
        if (this.divisionPlaceHolder != "Select") {
          this.model.DivisionCode = undefined;
          e.component.beginUpdate();
          e.component.option("value", undefined);
          e.component.endUpdate();
          return;
        }
        this.model.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
        if (this.baseView.mode != "create") {
          e.component.beginUpdate();
          if (!this.model.DivisionChanged) {
            e.component.option("value", undefined);
          } else {
            e.component.option(
              "value",
              this.defaultDataModel.DefaultDivisionCode
            );
          }

          e.component.endUpdate();
        }
      }
    },
    async onBranchCodeValueChanged(e) {
      let confirmBranchChange = await this.$confirm(
        "Changing the branch will update the branch for all PO lines, are you sure you want to continue?",
        "Confirm Branch Change"
      );

      if (confirmBranchChange) {
        this.branchPlaceHolder = "Select";
        this.model.BranchChanged = true;
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode;
        this.defaultDataModel.DefaultBranchDescription = e.itemData.Description;
        this.model.DeliverTo = e.itemData.Code;
        this.model.DeliveryAddressCompanyName = e.itemData.Description;

        if (this.baseView.mode != "create")
          this.$refs["purchase-order"].$refs["gc-header-form-component"].$refs[
            "gc-header-form"
          ].formRepaint();

        this.setDeliverTo(this.model, e);

        this.reviewDataSource.forEach((x) => {
          x.BranchCode = this.defaultDataModel.DefaultBranchCode;
          x.BranchDescription = this.defaultDataModel.DefaultBranchDescription;
        });

        var grid = this.$refs["purchase-order"].$refs["transactionGrid"];
        grid.gridRepaint();
      } else {
        if (this.branchPlaceHolder != "Select") {
          this.model.BranchCode = undefined;
          e.component.beginUpdate();
          e.component.option("value", undefined);
          e.component.endUpdate();
          return;
        }
        this.model.BranchCode = this.defaultDataModel.DefaultBranchCode;
        if (this.baseView.mode != "create") {
          e.component.beginUpdate();
          if (!this.model.BranchChanged) {
            e.component.option("value", undefined);
          } else {
            e.component.option(
              "value",
              this.defaultDataModel.DefaultBranchCode
            );
          }

          e.component.endUpdate();
        }
      }
    },
    exchangeRateValidator() {
      alert("Hello");
    },
    addToValidationSum(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    addInToGridValidations(getindex, msgObj) {
      this.brokenGridValidations[getindex] = msgObj;
    },
    pushInTOGridValidations(msgObj) {
      this.brokenGridValidations.push(msgObj);
    },
    removeFromGridValidations(getindex) {
      this.brokenGridValidations.splice(getindex, 1);
    },
    async copyPurchaseOrder() {
      let confirmLeaving = await this.$confirm(
        "Do you want to copy the Purchase Order ?",
        "Copy Purchase Order"
      );

      if (confirmLeaving) {
        this.reload = true;

        this.$router
          .push({
            path: `/purchase-order/create`,
          })
          .then(() => {
            this.model.SupplierCode = this.model.Supplier.Code;
            this.model.DateIn = new Date();
            this.model.Status = "D";
            this.model.Code = 0;
            this.model.GoodsIn = false;
            this.model.Status = "A";
            this.isCopiedOrder = true;

            this.reload = false;
          });
      }
    },
    async getDetailRecord() {
      return await PurchaseOrderDetail.getByCode(this.baseView.id);
    },
    setLineNo() {
      const maxLineNo = Math.max.apply(
        Math,
        this.reviewDataSource.map(function(o) {
          return o.LineNo;
        })
      );

      this.reviewDataSource[this.reviewDataSource.length - 1].LineNo =
        maxLineNo + 1;
      this.reviewDataSource[
        this.reviewDataSource.length - 1
      ].isNewRecord = true;
    },
    footerValueCalculations(lineData) {
      lineData.data.FXLineTotal = parseFloat(
        parseFloat(lineData.data.SupplierRequired).roundNumber(4) *
          parseFloat(lineData.data.SupplierFXPrice).roundNumber(4)
      ).roundNumber(2);

      lineData.data.TaxFXLineTotal = parseFloat(
        parseFloat(lineData.data.FXLineTotal).roundNumber(2) *
          parseFloat(lineData.data.TaxPcnt).roundNumber(4) *
          0.01
      ).roundNumber(2);

      lineData.data.TotalWithTax =
        lineData.data.FXLineTotal + lineData.data.TaxFXLineTotal;
      // lineData.data.FXLineTotal + lineData.data.TaxFXLineTotal;

      lineData.data.RequiredQty =
        lineData.data.SupplierRequired * lineData.data.SupplierConversion;
      // currentRow.SupplierFXPrice = currentRow.SupplierPrice;
      // currentRow.FXPrice = currentRow.SupplierFXPrice;
      // currentRow.Price = currentRow.FXPrice * this.model.ExchangeRate;
      // currentRow.OutstandingQty = currentRow.RequiredQty - currentRow.ReceivedQty;
      // currentRow.SupplierOutstandingQuantity = currentRow.OutstandingQty * currentRow.SupplierConversion;
      // currentRow.FXLineTotal = currentRow.SupplierRequired * currentRow.SupplierFXPrice;
      // currentRow.ExTotal = currentRow.FXPrice * currentRow.RequiredQty;
    },
    async setTaxCodeDataSourceItems() {
      let taxCodeDS = TaxCategoryService.dataSourceConfig("api/Tax", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Description", asc: false }],
      });

      this.taxCodeDataSourceItems = await taxCodeDS.load();
    },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
      });

      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async onSupplierCodeValueChanged(e) {
      let itemData = e.itemData;
      if (!itemData) {
        return;
      }
      if (itemData.DefaultBranchCode) {
        BranchService.getByCode(itemData.DefaultBranchCode).then(({ data }) => {
          this.defaultDataModel.DefaultBranchDescription =
            data.value[0].Description;
          this.model.DeliveryAddressCompanyName = this.defaultDataModel.DefaultBranchDescription;
        });
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode =
          itemData.DefaultBranchCode;
        this.model.DeliverTo = itemData.DefaultBranchCode;
      } else if (getDefaultUserSettings().BranchCode) {
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode = this.model.DeliverTo = getDefaultUserSettings().BranchCode;
        BranchService.getByCode(getDefaultUserSettings().BranchCode).then(
          ({ data }) => {
            this.model.DeliveryAddressCompanyName = data.value[0].Description;
          }
        );
      } else {
        await BranchService.getDefault().then((res) => {
          this.defaultDataModel.DefaultBranchCode = this.model.BranchCode = this.model.DeliverTo =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultBranchDescription = this.model.DeliveryAddressCompanyName =
            res.data.value[0].Description;
        });
      }
      this.model.Supplier = itemData;
      this.model.SupplierCode = itemData.Code;
      this.model.SupplierName = itemData.Name;
      this.model.CurrencyCode = itemData.CurrencyCode;
      let result = await CompanyCurrencyService.getByCurrencyCode(
        this.model.CurrencyCode
      );
      this.model.ExchangeRate = result.data.value[0].SellRate;

      if (this.dataViewType != "product-list") {
        this.$store.dispatch("dataContext/setDataViewType", "product-list");
      }
    },

    async initialized() {
      await this.$store.dispatch(
        "screenFactors/getFactors",
        [616, 549, 550, 505, 95, 87, 565, 547, 18] // , 65, 66]
      );

      // this.defaultDataModel.DefaultBranchCode = this.model.BranchCode = getFactorByCode(65).Factorc;
      // this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode = getFactorByCode(66).Factorc;

      if (getDefaultUserSettings().BranchCode) {
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode = getDefaultUserSettings().BranchCode;
      } else {
        await BranchService.getDefault().then((res) => {
          this.defaultDataModel.DefaultBranchCode = this.model.BranchCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultBranchDescription =
            res.data.value[0].Description;
        });
      }

      if (getDefaultUserSettings().DivisionCode) {
        this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode = getDefaultUserSettings().DivisionCode;
      } else {
        await DivisionService.getDefault().then((res) => {
          this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultDivisionDescription =
            res.data.value[0].Description;
        });
      }

      if (!this.defaultDataModel.DefaultBranchDescription) {
        let resBranch = await BranchService.getByCode(
          this.defaultDataModel.DefaultBranchCode
        );
        this.defaultDataModel.DefaultBranchDescription =
          resBranch.data.value[0].Description;

        this.setDeliverTo(this.model, {
          itemData: resBranch.data.value[0],
        });
      }

      if (!this.defaultDataModel.DefaultDivisionDescription) {
        let resDivision = await DivisionService.getByCode(
          this.defaultDataModel.DefaultDivisionCode
        );
        this.defaultDataModel.DefaultDivisionDescription =
          resDivision.data.value[0].Description;
      }

      this.model.DeliverTo = this.defaultDataModel.DefaultBranchCode;

      if (this.baseView.mode == "create") {
        this.model.NextStatus = getFactorByCode(547).Factorc;
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
          (res) => {
            // this.model.DeliveryAddressCompanyName = res.data.value[0].Name;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
          }
        );

        // await BranchService.getByCode(
        //   this.defaultDataModel.DefaultBranchCode
        // ).then((response) => {
        //   if (response.data.value.length > 0) {
        //     this.model.DeliveryAddressStreetLine1 =
        //       response.data.value[0].PhysicalAddressStreetLine1;
        //     this.model.DeliveryAddressStreetLine2 =
        //       response.data.value[0].PhysicalAddressStreetLine2;
        //     this.model.DeliveryAddressSuburb =
        //       response.data.value[0].PhysicalAddressSuburb;
        //     this.model.DeliveryAddressState =
        //       response.data.value[0].PhysicalAddressState;
        //     this.model.DeliveryAddressPostcode =
        //       response.data.value[0].PhysicalAddressPostcode;
        //     this.model.DeliveryAddressCountry =
        //       response.data.value[0].PhysicalAddressCountry;
        //   }
        // });

        this.model.Name = "Purchase Order";
        this.loaded = true;
      } else {
        this.model.NextStatus = getFactorByCode(547).Factorc;

        await this.getDetailRecord().then((response) => {
          var branchCode,
            divisionCode = undefined;
          if (response.data.value.length > 0) {
            response.data.value.forEach((item) => {
              item.IsCopyLine = false;

              // var codes = response.data.value.filter(
              //   (x) => x.ItemCode == item.ItemCode
              // );
              // var copyItems = codes.filter((z) => z.CopyCode != undefined);

              // if (copyItems.length == 0) item.CopyCode = item.ItemCode + "-0";
              // else {
              //   item.CopyCode = item.ItemCode + "-" + copyItems.length;
              // }

              if (item.SupplierReceivedQty > 0) this.model.GoodsIn = true;

              if (item.ItemType == "S") {
                item.ProductCode = item.ItemCode;
                item.ProductDescription1 = item.ItemDescription;
                item.Code = item.ItemCode;
                item.Description = item.ItemDescription;
              }

              if (item.ItemType == "G") {
                item.Code = item.ItemCode;
                item.Description = item.ItemDescription;
              }

              item.ETADate = new Date(item.ETADate);
              item.RequiredByDate = new Date(item.RequiredByDate);

              this.footerValueCalculations({
                data: item,
              });

              this.addToReview(item);

              if (branchCode) {
                if (branchCode != item.BranchCode) {
                  this.model.BranchCode = undefined;
                  this.branchPlaceHolder = "Multiple entries specified";
                }
              } else {
                branchCode = item.BranchCode;
                this.model.BranchCode = item.BranchCode;
              }

              if (divisionCode) {
                if (divisionCode != item.DivisionCode) {
                  this.model.DivisionCode = undefined;
                  this.divisionPlaceHolder = "Multiple entries specified";
                }
              } else {
                divisionCode = item.DivisionCode;
                this.model.DivisionCode = item.DivisionCode;
              }

              if (item.ItemType == "G") {
                item.Code = item.ItemCode;
                item.Description = item.ItemDescription;

                item[this.getAccountSort("SortAccountBy").dataField] =
                  item.ItemCode;
                this.glEntryLocalItems.push(item);
              }
            });
          }
        });

        await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
          (res) => {
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          }
        );
        this.loaded = true;
      }
    },
    // eslint-disable-next-line no-unused-vars
    async saveData(headerData, getDetailLines) {
      if (!headerData.SupplierCode) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: `Supplier is required`,
        });
      } else {
        if (this.containsManualBatches() && this.model.GoodsReceived) {
          this.validationSummary = [];
          this.validationSummary.push({
            message:
              "Items on this Purchase Order have a manual batch method and cannot be received automatically.  Please perform the goods received manually.",
          });
        } else {
          this.saveOrder();
        }
      }
    },
    async saveOrder() {
      if (this.brokenGridValidations.length === 0) {
        if (!this.getPoSavePayload().PurchaseOrderDetails.length) {
          // entity.PurchaseOrderDetails[0].Comment
          this.validationSummary = [];
          this.validationSummary.push({
            message: `Purchase Order has no detail. Please add one or more lines before attempting to save the transaction again.`,
          });
          return;
        }
        // else if (this.getPoSavePayload().Comment.length >= 1000) {
        //   this.validationSummary = [];
        //   this.validationSummary.push({
        //     message: `comments only allow maximum length of 1000 characters.`,
        //   });
        //   return;
        // }
        else {
          this.setLoading = true;
          await PurchaseOrder.savePurchaseOrder(
            this.getPoSavePayload(),
            this.model.Code
          )
            .then(async (res) => {
              this.setLoading = false;
              if (this.baseView.mode == "create") {
                this.model.Name = undefined;
                this.model.Code = res.data.Code;
              }
              this.$notify(
                `Purchase Order ${this.model.Code} Successfully Saved`,
                "success"
              );
              let destinationMode =
                res.data.NextStatus == "D" ? "edit" : "review";
              this.setIgnoreRouteChangeConfirmation();
              this.reload = true;
              this.loaded = false;
              this.glEntryLocalItems = [];
              if (destinationMode == this.baseView.mode) this.beforeInit();
              else {
                var query = undefined;
                if (this.baseView.query && this.baseView.query.from)
                  query = { from: this.baseView.query.from };
                this.$router
                  .push({
                    path: `/purchase-order/${destinationMode}/${this.model.Code}`,
                    query: query,
                  })
                  .then(() => {
                    this.$store.dispatch(
                      "dataContext/setDataViewType",
                      "review"
                    );
                    this.beforeInit();
                  });
              }
            })
            .catch((error) => {
              this.setLoading = false;
              this.serverError = {
                err: error,
                msg: "Save purchase order Failed",
                time: new Date().getTime(),
              };
            });
        }
      } else {
        let validationMessages = this.brokenGridValidations.map((item) => {
          return `Item : ${
            item.Description
          } has a required quantity of ${this.formatNumber(
            item.RequiredQty
          )} which is below the received quantity of ${this.formatNumber(
            item.ReceivedQty
          )}.`;
        });
        this.validationSummary = [];
        var validations = [];
        validationMessages.forEach((element) => {
          validations.push({
            message: element,
          });
        });
        this.validationSummary = validations;
      }
    },
    getPoSavePayload() {
      let payload = {
        Code: this.model.Code,
        DateIn: this.model.DateIn.toSaveDate(),
        GoodsReceived: this.model.GoodsReceived ? "Y" : "N",
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        SupplierCode: this.model.SupplierCode,
        ExchangeRate: this.model.ExchangeRate,
        DeliveryInstruction1: this.model.DeliveryInstruction1,
        DeliveryInstruction2: this.model.DeliveryInstruction2,
        Comment1: this.model.Comment1,
        Comment2: this.model.Comment2,
        Comment3: this.model.Comment3,
        Comment4: this.model.Comment4,
        Comment5: this.model.Comment5,
        CurrentStatus: this.model.Status,
        NextStatus: this.model.NextStatus,
        PurchaseOrderDetails: [],
        B2BSupplierReferenceNo: this.model.B2BSupplierReferenceNo,
      };

      this.reviewDataSource.forEach((data) => {
        let detailObj = {
          BranchCode: data.BranchCode,
          Comment: data.Comment || "",
          DiscPcnt: data.DiscPcnt ? data.DiscPcnt : 0,
          DivisionCode: data.DivisionCode,
          ETADate: data.ETADate.toSaveDate(),
          FXPrice: data.SupplierFXPrice / data.SupplierConversion,
          IsVariable: data.IsVariable,
          ItemCode: data.ItemCode,
          ItemType: data.ItemType,
          LineNo: data.isNewRecord ? 0 : data.LineNo,
          Rank: data.Rank,
          RequiredQty: data.RequiredQty,
          RequiredByDate: data.RequiredByDate.toSaveDate(),
          SupplierConversion: data.SupplierConversion,
          SupplierRequired: data.SupplierRequired,
          SupplierUM: data.SupplierUM,
          TaxCode: data.TaxCode ? data.TaxCode : undefined,
          // TaxCode:data.CurrencyCode== "AUD" ? "G" : "E",
          // this.model.CurrencyCode == "AUD" ? "G" : "E",

          // data.TaxCode ? data.TaxCode : undefined,
        };
        payload.PurchaseOrderDetails.push(detailObj);
      });
      return payload;
    },

    async purchaseOrderPostProcess(data) {
      data.SupplierName = data.Supplier.Name;
      data.SupplierCode = data.Supplier.Code;
      data["NextStatus"] = getFactorByCode(547).Factorc;
      data.DateIn = new Date(data.DateIn);

      // - #31312: UI : Update Transaction Screen Template to Support PDF Button
      // - To match ScreenNameToLayout parameter.dataField
      data["PurchaseOrder"] = data.Code;

      if (this.model.BranchCode) data.BranchCode = this.model.BranchCode;
      if (this.model.DivisionCode) data.DivisionCode = this.model.DivisionCode;

      this.model = data;

      if (this.model.Status == "D" && this.baseView.mode !== "edit") {
        // force push screen to edit mode when the Sales Order is in Draft mode
        this.$router.push({
          path: `/purchase-order/edit/${this.model.Code}`,
        });
      }

      return data;
    },
    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    GLChartEntryPostProcess(data) {
      var items = [];
      var branchCode,
        divisionCode = undefined;

      // let etaDate = new Date();

      // if (this.defaultDataModel.ETADate)
      //   etaDate = this.defaultDataModel.ETADate;

      data.forEach((x) => {
        // x.IsCopyLine = false;
        // x.CopyCode = x.ItemCode + "-0";

        var item = undefined;

        var index = this.reviewDataSource.findIndex(
          (i) => i.CopyCode == x.CopyCode && i.IsGLEntry // && i.RecordId == x.RecordId
        );
        if (index == -1) {
          items.push(x);
          item = x;
        } else {
          items.push(this.reviewDataSource[index]);
          item = this.reviewDataSource[index];
        }

        // var item = undefined;
        // var reviewedItems = this.reviewDataSource.filter(
        //   (a) => a.ItemCode == x.ItemCode && a.IsGLEntry
        // );
        // if (reviewedItems.length > 0)
        //   reviewedItems.forEach((element) => {
        //     if (element.CopyCode != x.CopyCode && element.IsGLEntry) {
        //       items.push(element);
        //       item = element;
        //     }
        // });
        // else {
        //   items.push(x);
        //   item = x;
        // }

        if (branchCode && item) {
          if (branchCode != item.BranchCode) {
            this.model.BranchCode = undefined;
            this.branchPlaceHolder = "Multiple entries specified";
          }
        } else if (item) {
          branchCode = item.BranchCode;
          this.model.BranchCode = item.BranchCode;
          this.branchPlaceHolder = "Select";
        }

        if (divisionCode && item) {
          if (divisionCode != item.DivisionCode) {
            this.model.DivisionCode = undefined;
            this.divisionPlaceHolder = "Multiple entries specified";
          }
        } else if (item) {
          divisionCode = item.DivisionCode;
          this.model.DivisionCode = item.DivisionCode;
        }
      });

      // if (this.baseView.mode == "edit") {
      //   var reviewedItems = this.reviewDataSource.filter(
      //     (a) => a.ItemType == "G" && a.PurchaseOrderCode == this.baseView.id
      //   );
      //   if (reviewedItems.length > 0)
      //     reviewedItems.forEach((element) => {
      //       //             ItemCode: "15015"
      //       // ItemDescription: "Purchases Packaging"

      //       element.Code = element.ItemCode;
      //       element.Description = element.ItemDescription;

      //       element[this.getAccountSort("SortAccountBy").dataField] =
      //         element.ItemCode;
      //       items.push(element);
      //     });
      // }

      if (this.searchText && items.length > 0)
        items = items.filter(this.filterFunction);

      if (items.length == 0) this.glEntryLocalItems.push({ ...glEntryDataSet });
      return items;
    },
    GLChartPostProcess(data) {
      var items = [];
      var branchCode,
        divisionCode = undefined;

      let etaDate = new Date();

      if (this.defaultDataModel.ETADate)
        etaDate = this.defaultDataModel.ETADate;

      data.forEach((x) => {
        x["BranchCode"] = this.defaultDataModel.DefaultBranchCode;
        x["BranchDescription"] = this.defaultDataModel.DefaultBranchDescription;
        x["DivisionCode"] = this.defaultDataModel.DefaultDivisionCode;
        x[
          "DivisionDescription"
        ] = this.defaultDataModel.DefaultDivisionDescription;
        x["RequiredByDate"] = new Date();
        x["ETADate"] = etaDate;
        x["SupplierUM"] = "Ea";
        x["SupplierRequired"] = 0;
        x["SupplierReceivedQty"] = 0;
        x["IsBatchProduct"] = "No";
        x["SupplierFXPrice"] = 0;
        x["FXLineTotal"] = 0;
        x.ItemCode = x.Code.toString();
        x.ItemDescription = x.Description;
        x.ItemType = "G";
        x.TaxableFXLineTotal = 0;
        x.TaxFXLineTotal = 0;
        x.FXTotal = 0;
        x.TotalWithTax = 0;
        x.LineNo = 0;
        x.SupplierConversion = 1;
        x.SupplierPrice = 0;
        x.TaxPcnt = 0;
        x.IsVariable = "N";
        x.IsCopyLine = false;
        x.CopyCode = x.ItemCode + "-0";
        // x.TaxCode = this.model.CurrencyCode == "AUD" ? "G" : "E";
        if (x.ItemType == "G" && this.model.CurrencyCode != "AUD") {
          x.TaxCode = "E";
        } else x.TaxCode = "G";

        var tax = this.taxCodeDataSourceItems.filter(
          (t) => t.Code == x.TaxCode
        );
        if (tax.length > 0) x.TaxPcnt = tax[0].Rate;
        x.Comment = "";

        // var index = this.reviewDataSource.findIndex(
        //   (i) => i.CopyCode == x.CopyCode && !i.IsGLEntry //&& i.RecordId == x.RecordId
        // );
        var item = undefined;
        // if (index == -1) {

        //   items.push(x);
        //   item = x;
        // } else {
        //   items.push(this.reviewDataSource[index]);
        //   item = this.reviewDataSource[index];
        // }

        // var item = undefined;
        var reviewedItems = this.reviewDataSource.filter(
          (a) => a.ItemCode == x.ItemCode && a.ItemType == "G"
        );
        if (reviewedItems.length > 0) {
          reviewedItems.forEach((element) => {
            items.push(element);
            item = element;
          });
        } else {
          items.push(x);
          item = x;
        }

        if (branchCode) {
          if (branchCode != item.BranchCode) {
            this.model.BranchCode = undefined;
            this.branchPlaceHolder = "Multiple entries specified";
          }
        } else {
          branchCode = item.BranchCode;
          this.model.BranchCode = item.BranchCode;
          this.branchPlaceHolder = "Select";
        }

        if (divisionCode) {
          if (divisionCode != item.DivisionCode) {
            this.model.DivisionCode = undefined;
            this.divisionPlaceHolder = "Multiple entries specified";
          }
        } else {
          divisionCode = item.DivisionCode;
          this.model.DivisionCode = item.DivisionCode;
        }
      });

      if (this.searchText) items = items.filter(this.filterFunction);
      return items;
    },
    ProductPostProcess(data) {
      var items = [];
      var branchCode = undefined;
      var divisionCode = undefined;
      data.forEach((x) => {
        let defaultRequiredByDate = new Date();
        defaultRequiredByDate.setDate(
          defaultRequiredByDate.getDate() + x.SupplierLead
        );

        let etaDate = undefined;

        if (this.defaultDataModel.ETADate)
          etaDate = this.defaultDataModel.ETADate;
        else etaDate = defaultRequiredByDate;

        x.BranchCode = this.defaultDataModel.DefaultBranchCode;
        // x.BranchDescription = this.defaultDataModel.DefaultBranchDescription;
        // x.BranchDescription = this.model.BranchDescription;
        x.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
        x.DivisionDescription = this.defaultDataModel.DefaultDivisionDescription;
        x.RequiredByDate = defaultRequiredByDate;
        x.ETADate = etaDate;
        // x.SupplierUM = "Ea";
        x.SupplierRequired = 0;
        x.SupplierReceivedQty = 0;
        // x.IsBatchProduct = "No";
        x.SupplierFXPrice = 0;
        x.FXLineTotal = 0;
        x.ItemCode = x.ProductCode;
        x.ItemDescription = x.ProductDescription1;
        x.Code = x.ProductCode;
        x.Description = x.ProductDescription1;
        x.TaxableFXLineTotal = 0;
        x.TaxFXLineTotal = 0;
        x.FXTotal = 0;
        x.TotalWithTax = 0;
        x.ItemType = "S";
        x.LineNo = 0;
        x.IsVariable = "N";
        x.Comment = "";
        x.ComputedStringCode = x.Code.toString();
        if (this.model.CurrencyCode != "AUD") {
          x.TaxCode = "E";
        }
        x.IsCopyLine = false;
        x.CopyCode = x.ItemCode + "-0";

        if (x.TaxCode == "E") x.TaxPcnt = 0;

        var item = undefined;

        // var index = this.reviewDataSource.findIndex(
        //   (i) => i.CopyCode == x.CopyCode //&& i.RecordId == x.RecordId
        // );
        // if (index == -1) {
        //   items.push(x);
        //   item = x;
        // } else {
        //   items.push(this.reviewDataSource[index]);
        //   item = this.reviewDataSource[index];
        // }

        var reviewedItems = this.reviewDataSource.filter(
          (a) => a.ItemCode == x.ItemCode
        );
        if (reviewedItems.length > 0)
          reviewedItems.forEach((element) => {
            if (element.CopyCode == x.CopyCode) {
              items.push(element);
              item = element;
            }
          });
        else {
          items.push(x);
          item = x;
        }

        if (branchCode) {
          if (branchCode != item.BranchCode) {
            this.model.BranchCode = undefined;
            this.branchPlaceHolder = "Multiple entries specified";
          }
        } else {
          branchCode = item.BranchCode;
          this.model.BranchCode = item.BranchCode;
          this.branchPlaceHolder = "Select";
        }

        if (divisionCode) {
          if (divisionCode != item.DivisionCode) {
            this.model.DivisionCode = undefined;
            this.divisionPlaceHolder = "Multiple entries specified";
          }
        } else {
          divisionCode = item.DivisionCode;
          this.model.DivisionCode = item.DivisionCode;
        }

        // var itm = this.reviewDataSource.filter((i) => i.ItemCode == x.ItemCode);
        // if (itm.length == 0) items.push(x);
        // else
        //   itm.forEach((element) => {
        //     items.push(element);
        //   });
      });

      // this.reviewDataSource.forEach((element) => {});

      if (this.searchText) items = items.filter(this.filterFunction);
      return items;
    },

    filterFunction(x) {
      return (
        (x.ItemCode &&
          x.ItemCode.toLowerCase().indexOf(this.searchText.toLowerCase()) !==
            -1) ||
        (x.ItemDescription &&
          x.ItemDescription.toLowerCase().indexOf(
            this.searchText.toLowerCase()
          ) !== -1)
      );
    },

    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    containsManualBatches() {
      let hasManualBatch = false;

      for (const item of this.reviewDataSource) {
        if (item.IsBatchProduct === "Manual") {
          hasManualBatch = true;
          break;
        }
      }

      return hasManualBatch;
    },
    ReviewModePostProcess(data) {
      var branchCode,
        divisionCode = undefined;
      data.forEach((item) => {
        if (branchCode) {
          if (branchCode != item.BranchCode) {
            this.model.BranchCode = undefined;
            this.branchPlaceHolder = "Multiple entries specified";
          }
        } else {
          branchCode = item.BranchCode;
          this.model.BranchCode = item.BranchCode;
          this.branchPlaceHolder = "Select";
        }

        if (divisionCode) {
          if (divisionCode != item.DivisionCode) {
            this.model.DivisionCode = undefined;
            this.divisionPlaceHolder = "Multiple entries specified";
          }
        } else {
          divisionCode = item.DivisionCode;
          this.model.DivisionCode = item.DivisionCode;
        }
        if (this.baseView.mode == "review") {
          if (item.PurchaseDescription) {
            item.Description = item.PurchaseDescription;
          }
          item.ProductCode = item.ItemCode;
        } else {
          if (item.PurchaseDescription1) {
            item.PurchaseDescription = item.PurchaseDescription1;
          } else {
            item.PurchaseDescription = item.Description;
          }
          if (!item.ProductCode) {
            if (item.ComputedStringCode) {
              item.ProductCode = item.ComputedStringCode;
            } else {
              item.ProductCode = item.Code;
            }
          }
        }
      });
      return data;
    },
  },
};
</script>

<style lang="scss">
.class-multiple {
  .dx-selectbox-container .dx-texteditor-container .dx-placeholder {
    color: black;
  }
}
</style>
